import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { Button, Main } from '../../components';
import useClasses from '../../hooks/useClasses';
import useRoutes from '../../hooks/useRoutes';

export interface PageNotFoundProps {
  homeRoute: string;
}

const PageNotFoundContent: React.FC<PageNotFoundProps> = ({ homeRoute }) => {
  const { t } = useTranslation();
  const { buildClass, joinClasses } = useClasses('PageNotFound');

  return (
    <div className={joinClasses(buildClass(), 'col-md-8 offset-md-2 py-8 py-lg-12')}>
      <h1>{t('pages.404.title')}</h1>

      <p className="mt-3 mt-lg-5 mb-6">
        {t('pages.404.body')}
      </p>

      <Button href={homeRoute}>
        {t('pages.404.button')}
      </Button>
    </div>
  );
};

const PageNotFound: React.FC = () => {
  const { program, landing } = useRoutes();

  const isLoggedIn = useSelector<ImmutableRootState<boolean>, boolean>((state) => state.getIn(['login', 'loggedIn'], null));

  if (isLoggedIn) {
    return <PageNotFoundContent homeRoute={program} />;
  }

  return (
    <Container>
      <Main>
        <div className="row">
          <PageNotFoundContent homeRoute={landing} />
        </div>
      </Main>
    </Container>
  );
};

export default PageNotFound;
